var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseOutstanding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21.5,
    r: 15.75,
    fill: "#B00020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3828 28.1172C16.2422 29.9401 18.4479 30.8516 21 30.8516C23.5521 30.8516 25.7396 29.9401 27.5625 28.1172C29.4219 26.2578 30.3516 24.0521 30.3516 21.5C30.3516 18.9479 29.4219 16.7604 27.5625 14.9375C25.7396 13.0781 23.5521 12.1484 21 12.1484C18.4479 12.1484 16.2422 13.0781 14.3828 14.9375C12.5599 16.7604 11.6484 18.9479 11.6484 21.5C11.6484 24.0521 12.5599 26.2578 14.3828 28.1172ZM12.7422 13.2969C15.0391 11 17.7917 9.85156 21 9.85156C24.2083 9.85156 26.9427 11 29.2031 13.2969C31.5 15.5573 32.6484 18.2917 32.6484 21.5C32.6484 24.7083 31.5 27.4609 29.2031 29.7578C26.9427 32.0182 24.2083 33.1484 21 33.1484C17.7917 33.1484 15.0391 32.0182 12.7422 29.7578C10.4818 27.4609 9.35156 24.7083 9.35156 21.5C9.35156 18.2917 10.4818 15.5573 12.7422 13.2969ZM19.8516 15.6484H22.1484V22.6484H19.8516V15.6484ZM19.8516 25H22.1484V27.3516H19.8516V25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseOutstanding);
export default __webpack_public_path__ + "static/media/course-outstanding.33a43d9ae199db040d0cbf7cab8851d0.svg";
export { ForwardRef as ReactComponent };